import { render, staticRenderFns } from "./AssetsCatalogTable.vue?vue&type=template&id=14ff9c59"
import script from "./AssetsCatalogTable.vue?vue&type=script&lang=js"
export * from "./AssetsCatalogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports